import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { portalApi } from '../../api';

// 客户网页端「激活码自助开通」：输入激活码 → 系统自动建号+生成专属密码+开通权限
// 凭据当场显示（密码只显示这一次），无需短信、无需等待人工
export default function PortalActivate() {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [result, setResult] = useState<any>(null);
  const [copied, setCopied] = useState(false);
  const nav = useNavigate();

  const submit = async (e: any) => {
    e.preventDefault();
    setErr('');
    if (!code.trim()) return setErr('请输入激活码');
    if (!name.trim()) return setErr('请填写公司 / 客户名称');
    if (phone.trim() && !/^1\d{10}$/.test(phone.trim())) return setErr('手机号格式不正确');
    setBusy(true);
    try {
      const d = await portalApi('/redeem', {
        method: 'POST',
        body: JSON.stringify({
          code: code.trim().toUpperCase(),
          name: name.trim(),
          contact: contact.trim() || undefined,
          phone: phone.trim() || undefined,
        }),
      });
      setResult(d);
    } catch (e: any) {
      setErr(e.message || '开通失败，请核对激活码');
    } finally {
      setBusy(false);
    }
  };

  const copy = async () => {
    if (!result) return;
    const text = `荣牧科技 ERP 登录信息\n客户编码：${result.code}\n专属密码：${result.password}\n登录网址：https://erp.rongmukj.com/portal`;
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="h-full flex items-center justify-center bg-gradient-to-br from-emerald-700 to-emerald-900 px-4 py-8 overflow-auto">
      <div className="bg-white p-7 rounded-2xl shadow-xl w-full max-w-sm space-y-5">
        {!result ? (
          <form onSubmit={submit} className="space-y-4">
            <div className="text-center">
              <div className="text-3xl mb-1">🎟️</div>
              <h1 className="text-xl font-bold">激活码开通 ERP</h1>
              <p className="text-xs text-slate-400 mt-1">输入激活码，系统自动为您开通账号</p>
            </div>
            <input
              className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base tracking-wide font-semibold text-emerald-800 focus:ring-2 focus:ring-emerald-500 outline-none"
              placeholder="激活码，如 RM-7K3M-9PQX"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
            />
            <input
              className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-emerald-500 outline-none"
              placeholder="公司 / 客户名称 *"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-emerald-500 outline-none"
              placeholder="联系人"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
            <input
              className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-emerald-500 outline-none"
              placeholder="手机号（选填）"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            {err && <div className="text-red-500 text-sm text-center">{err}</div>}
            <button
              disabled={busy}
              className="w-full bg-emerald-600 text-white rounded-lg py-3 text-base font-bold hover:bg-emerald-700 active:scale-95 transition disabled:opacity-60"
            >
              {busy ? '正在开通…' : '立即开通'}
            </button>
            <div className="text-xs text-slate-400 text-center">
              还没有激活码？请联系荣牧科技业务员获取。
              <br />
              <a href="/portal/login" className="text-emerald-600 underline">已有账号？返回登录</a>
            </div>
          </form>
        ) : (
          <div className="space-y-4">
            <div className="text-center">
              <div className="text-3xl mb-1">🎉</div>
              <h1 className="text-xl font-bold">开通成功</h1>
              <p className="text-xs text-red-500 mt-1">请立即保存，密码只显示这一次</p>
            </div>
            <div className="bg-slate-50 rounded-xl divide-y divide-slate-200 text-sm">
              <div className="flex justify-between px-4 py-3">
                <span className="text-slate-400">客户编码</span>
                <span className="font-bold">{result.code}</span>
              </div>
              <div className="flex justify-between px-4 py-3">
                <span className="text-slate-400">专属密码</span>
                <span className="font-bold font-mono text-red-600 tracking-wide">{result.password}</span>
              </div>
              {result.plan && (
                <div className="flex justify-between px-4 py-3">
                  <span className="text-slate-400">套餐</span>
                  <span className="font-medium">{result.plan}</span>
                </div>
              )}
              {result.license_expire_at && (
                <div className="flex justify-between px-4 py-3">
                  <span className="text-slate-400">有效期至</span>
                  <span className="font-medium">{result.license_expire_at}</span>
                </div>
              )}
            </div>
            <button onClick={copy} className="w-full bg-emerald-600 text-white rounded-lg py-3 text-base font-bold hover:bg-emerald-700 transition">
              {copied ? '已复制 ✓' : '复制登录信息'}
            </button>
            <button onClick={() => nav('/portal/login')} className="w-full bg-emerald-50 text-emerald-700 rounded-lg py-3 text-base font-bold hover:bg-emerald-100 transition">
              去登录
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
